import { Component, inject, Input } from '@angular/core';
import { Headers_CCP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Headers-CCP.interface';
import { Data_User_CDMS } from 'src/app/Interfaces/Admin/Data_User_CDMS.interface';
import { LIBRARYCCPService } from 'src/app/Services/Libraries/General-CCP/library-ccp.service';
import { firstValueFrom } from 'rxjs';
import Swal from 'sweetalert2';
import { FilterUserPipe } from 'src/app/Pipes/Admin/filter-user.pipe';
import { Response_CCP } from 'src/app/Interfaces/Interfaces-Global/Response.interface';
import { AdminService } from 'src/app/Services/Global/Admin/admin.service';
import { Response_Admin } from 'src/app/Interfaces/Admin/Response_Admin.interface';
import { RoleCCP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Role/CreateRoleCCP.interface';

@Component({
    selector: 'app-see-users-in-role-ccp',
    templateUrl: './see-users-in-role-ccp.component.html',
    styleUrls: ['./see-users-in-role-ccp.component.scss', '../../../../../Styles/GlobalStyles.css'],
    standalone: false
})
export class SeeUsersInRoleCCPComponent {
  //+================== VARIABLES FOR HEADERS TASK ==================+\\
  public Headers_Role: Headers_CCP[] = [
    { ID: 1, Name: 'Nombre', Position: 1, Visible: true, Key_Header: 'NAME' },
    { ID: 1, Name: 'Correo electrónico', Position: 1, Visible: true, Key_Header: 'EMAI' },
    { ID: 1, Name: 'LoginName', Position: 1, Visible: true, Key_Header: 'LONA' },
    { ID: 1, Name: 'Opciones', Position: 1, Visible: true, Key_Header: 'OPTI' },
  ];

  //+================== VARIABLES FOR SEARCH ==================+\\
  public Input_Search: string = '';
  public Input_Search_User: string = '';


  //+================== VARIABLES FOR PAGINATION ==================+\\
  public first: number = 0;
  public rows: number = 10;

  //+================== VARIABLES FOR COLOR SWETALERT ==================+\\
  private ColorConfirm: string = '#20a8e1';
  private ColorsCancel: string = '#fc6161';


  //+================== VARIABLES FOR LOAD PAGE ==================+\\
  public LoadPage: boolean = false;

  //+================== VARIABLES FOR ROLES ==================+\\
  public All_User_Rol: Data_User_CDMS[] = [];
  public Selected_All_User_Rol: Data_User_CDMS[] = [];

  public All_User_CDMS: Data_User_CDMS[] = [];
  public All_User_CDMS_Copy: Data_User_CDMS[] = [];
  public All_User_CDMS_Copy_Search: Data_User_CDMS[] = [];

  public Role: RoleCCP = {
    ID: 0,
    Name: '',
    Description: '',
  }

  //+================== VARIABLES FOR SNAPSHOTS ==================+\\
  @Input('IDR') ID_Role: number = 0;


  //-========================= SERVICES =========================-\\
  private Service_CCP = inject(LIBRARYCCPService);
  private Service_Admin = inject(AdminService);

  constructor() { }


  ngOnInit(): void {
    this.Load_Component();
  }

  //&===================== FUNCTIONS FOR LOAD COMPONENT =====================&\\


  //-================== FUNCTTION FOR LOAD COMPONENT ==================-\\
  private async Load_Component(): Promise<void> {

    const Loader = document.getElementById('Loader') as HTMLDivElement;
    Loader.classList.add('active');

    try {

      await this.Load_All_Users();
      await this.Load_All_User_In_Role();
      this.Clean_User_Relation();

      Loader.classList.remove('active');
      this.LoadPage = true;
    } catch (e) {

      Swal.fire({
        title: 'Ocurrió un error (Usuarios)',
        text: '¡Recargue la página, si el problema persiste notifique a supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      });
      Loader.classList.remove('active');
      this.LoadPage = true;
    }

  }

  //-================== FUNCTTION FOR LOAD ALL USERS ==================-\\
  private async Load_All_Users(): Promise<boolean> {

    try {

      const ResUsers: Response_Admin = await firstValueFrom(this.Service_Admin.Get_All_Users_CDMS());

      if (ResUsers.success) {

        this.All_User_CDMS = ResUsers.operation;
        return true;

      } else {
        throw ResUsers.message;
      }

    } catch (e) {

      Swal.fire({
        title: 'Ocurrió un error (Usuarios)',
        text: '¡Recargue la página, si el problema persiste notifique a supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      });
      return false;
    }
  }

  //-================== FUNCTTION FOR LOAD USERS IN ROLE ==================-\\
  private async Load_All_User_In_Role(): Promise<boolean> {

    try {

      const ResUsers_In_R: Response_Admin = await firstValueFrom(this.Service_CCP.Get_Users_Role_CCP({ ID_Role: this.ID_Role }));

      if (ResUsers_In_R.success) {

        this.All_User_Rol = ResUsers_In_R.operation.users;
        this.Role = ResUsers_In_R.operation.Role;

        return true;

      } else {
        throw ResUsers_In_R.message;
      }

    } catch (e) {

      Swal.fire({
        title: 'Ocurrió un error (Usuarios en rol)',
        text: '¡Recargue la página, si el problema persiste notifique a supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      });
      return false;
    }
  }

  //&===================== END FUNCTIONS FOR LOAD COMPONENT =====================&\\

  //-================== FUNCTTION FOR CLEAN USERS ==================-\\
  private Clean_User_Relation(): boolean {

    const Clean_User: Data_User_CDMS[] = [];

    this.All_User_CDMS.forEach((Item: Data_User_CDMS) => {
      this.All_User_Rol.some((Item_F: Data_User_CDMS) => Item_F.Nombre === Item.Nombre) ? 0 : Clean_User.push(Item);
    })

    this.All_User_CDMS = Clean_User;
    this.All_User_CDMS_Copy = this.All_User_CDMS.slice(this.first, this.first + this.rows)

    return true;
  }


  //-================== FUNCTTION FOR FORMAT LOGIN NAME ==================-\\
  public Format_LoginName(LoginName: string): string {
    return LoginName.trim() === '' ? 'CDMS' : LoginName.trim();
  }

  //-================== FUNCTTION FOR INITIALS CARD ==================-\\
  public Format_Initials(Name: string): string {
    let Initials: string = '';
    let NameSplit: string[] = Name.split(' ');

    Initials += NameSplit[0][0] || '?';
    NameSplit.length > 1 ? Initials += NameSplit[1][0] || '' : Initials += NameSplit[0][1] || '';

    return Initials;
  }

  //-================== FUNCTTION FOR ADD CLASS IF EXIST MAIL ==================-\\
  public ContainMail(Mail: string): string {
    return Mail.trim() === '' ? 'Not-Mail' : 'Mail';
  }

  //-================== FUNCTTION FOR FORMAT MAIL ==================-\\
  public Format_Mail(Mail: string): string {
    return Mail.trim() === '' ? 'Sin Correo' : Mail.trim();
  }

  //-================== FUNCTTION FOR RELOAD PAGE ==================-\\
  public Reload_Page(): void {
    this.Load_Component();
  }

  //-================== FUNCTTION FOR PAGINATION ==================-\\
  public onPageChange(event: any): void {

    this.first = event.first;
    this.rows = event.rows;

    this.All_User_CDMS_Copy = this.Input_Search_User.length < 2 ? this.All_User_CDMS.slice(event.first, event.first + event.rows) : this.All_User_CDMS_Copy_Search.slice(event.first, event.first + event.rows);

  }

  //-================ FUNCTION FOR VALIDATE SEARCH ================-\\
  public Search_Validate(): void {

    if (this.Input_Search.length < 2) {
      Swal.fire({
        title: 'búsqueda no valida',
        text: '¡La búsqueda es muy corta, mínimo 2 caracteres!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      });
    } else {
      this.Search_User();
    }

  }

  //-================ FUNCTION FOR SEARCH WHIT KEY ENTER ================-\\
  public Search_Enter($event: KeyboardEvent): void {
    $event.code === 'Enter' ? this.Search_Validate() : 0;
  }

  //-================== FUNCTTION FOR SEARCH USER ==================-\\
  public Search_User(): void {
    this.Input_Search_User == '' || this.Input_Search_User.length < 2 ?
      this.All_User_CDMS_Copy = this.All_User_CDMS.slice(this.first, this.first + this.rows) :
      (this.All_User_CDMS_Copy_Search = new FilterUserPipe().transform(this.All_User_CDMS, this.Input_Search_User), this.All_User_CDMS_Copy = this.All_User_CDMS_Copy_Search.slice(this.first, this.first + this.rows));
  }

  //&===================== END FUNCTIONS FOR GENERAL COMPONENT =====================&\\


  //&===================== FUNCTIONS FOR UPDATE USER =====================&\\

  //-================== FUNCTTION FOR OPEN MODAL TO RELATION USER ==================-\\
  public Toggle_Modal_Relation_User(Close_Or_Open: boolean): void {
    const Modal_Relation_User = document.getElementById('Modal_Relation_User') as HTMLElement;
    Close_Or_Open ? Modal_Relation_User.classList.add('active') : Modal_Relation_User.classList.remove('active');
  }
  //-================== FUNCTTION FOR SAVE RELATION USER ==================-\\
  public Add_User_To_Role(User: Data_User_CDMS): void {

    Swal.fire({
      title: '¿Desea agregar el usuario al rol?',
      text: `¡${User.Nombre} ahora será parte de ${this.Role.Name}!`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: '¡sí, agregar!'
    }).then(async (result) => {

      if (result.isConfirmed) {

        try {

          const ResRelation: Response_Admin = await firstValueFrom(this.Service_CCP.Relate_User_Role_CCP({ ID_Role: this.Role.ID, ID_User: User.ID }))

          if (ResRelation.success) {
            this.All_User_Rol = [...this.All_User_Rol, User];
            this.Input_Search_User = '';
            this.Clean_User_Relation();

            const Toast = Swal.mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 2000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer)
                toast.addEventListener('mouseleave', Swal.resumeTimer)
              }
            })

            Toast.fire({
              icon: 'success',
              title: '¡Usuario agregado!'
            })
          } else {
            throw ResRelation.message;
          }

        } catch (e) {
          Swal.fire({
            title: 'Ocurrió un error',
            text: '¡Intente nuevamente agregar el usuario al rol, si el problema persiste notifique a supervisor!',
            icon: 'warning',
            confirmButtonColor: this.ColorConfirm
          });
        }


      }

    })
  }

  //&===================== END FUNCTIONS FOR UPDATE USER =====================&\\

  //&===================== FUNCTIONS FOR DELETE USER =====================&\\

  //-================== FUNCTTION FOR DELETE RELATION USER ==================-\\
  public Delete_User_To_Role(User: Data_User_CDMS): void {

    Swal.fire({
      title: '¿Desea eliminar el usuario al Rol?',
      text: `¡${User.Nombre} se eliminará de ${this.Role.Name}!`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: '¡sí, eliminar!'
    }).then(async (result) => {

      if (result.isConfirmed) {

        try {

          const ResRelation: Response_Admin = await firstValueFrom(this.Service_CCP.Delete_User_Role_CCP({ ID_Role: this.Role.ID, ID_User: User.ID }))

          if (ResRelation.success) {

            this.All_User_Rol = this.All_User_Rol.filter(item => item.ID !== User.ID);
            this.All_User_CDMS.push(User);

            this.Clean_User_Relation();

            const Toast = Swal.mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 2000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer)
                toast.addEventListener('mouseleave', Swal.resumeTimer)
              }
            })

            Toast.fire({
              icon: 'success',
              title: '¡Usuario eliminado correctamente!'
            })
          } else {
            throw ResRelation.message;
          }

        } catch (e) {
          Swal.fire({
            title: 'Ocurrió un error',
            text: '¡Intente nuevamente el usuario del rol, si el problema persiste notifique a supervisor!',
            icon: 'warning',
            confirmButtonColor: this.ColorConfirm
          });
        }


      }

    })
  }
  //&===================== END FUNCTIONS FOR DELETE USER =====================&\\

}
